import {DateMapper} from "@app/core/shared/infrastructure/mappers/date.mapper";
import {Coupon} from "../../domain/dtos/coupon";

export class CouponMapper {
    static deserialize(param: any): Coupon {
        return {
            code: param.code,
            discountedAmount: param.dis_amount,
            discountedPercentage: param.dis_percentage,
            minimumAmount: param.min_amount,
            endDate: DateMapper.deserialize(param.date),
            relatedProducts: param.relatedProducts
        } as Coupon
    }

    static serialize(param: Coupon): any {
        return {
            code: param.code,
            dis_amount: param.discountedAmount,
            dis_percentage: param.discountedPercentage,
            min_amount: param.minimumAmount,
            date: param.endDate,
            relatedProducts: param.relatedProducts
        }
    }

}
